// extracted by mini-css-extract-plugin
module.exports = {"preview":"FilePreviewModal_preview___N0Gj","object":"FilePreviewModal_object__bVhEE","embed":"FilePreviewModal_embed__RVS1L"};